import React from 'react';
import { RoutePath } from "./routes";
import { Routes, Route } from 'react-router-dom'

import Home from './page/Home'
import Team from './page/Team'
import WorkPage from './page/WorkPage'
import Services from './page/Services'
import AboutPage from './page/About'
import AdminPage from './Admin/Admin'
import ContactPage from './page/ContactPage'
import BlogCardPage from './page/BlogCardPage'
import BlogPage from './page/BlogPage'
import PrivacyPolicy from './page/PrivacyPolicy'

function App() {
  return (
    <>
      <Routes>
        <Route path={RoutePath.Home} element={ <Home /> } />
        <Route path={RoutePath.Team} element={ <Team /> } />
        <Route path={RoutePath.Work} element={ <WorkPage /> } />
        <Route path={RoutePath.Services} element={ <Services /> } />
        <Route path={RoutePath.About} element={ <AboutPage /> } />
        <Route path={RoutePath.Panel} element={ <AdminPage /> } />
        <Route path={RoutePath.Contact} element={ <ContactPage /> } />
        <Route path={RoutePath.BlogCard} element={ <BlogCardPage /> } />
        <Route path={RoutePath.BlogPage} element={<BlogPage />} />
        <Route path={RoutePath.PrivacyPolicy} element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

export default App;